/* Team headshots.

   Hosted in Firebase Storage rather than bundled: this build has no static-asset
   pipeline (no public/ dir, no image imports anywhere — every image in the app is
   a hosted URL), so a photo dropped in the repo would never reach dist/.

   `assets/**` is world-readable per storage.rules, so these need no auth to load.
   Upload the four files to  assets/team/  in the connct-cba18 bucket, named exactly
   as below. Until a file exists, TeamAvatar keeps showing the person's initials —
   it never renders a broken image. */

const BASE = 'https://storage.googleapis.com/connct-cba18.firebasestorage.app/assets/team';

export const TEAM_PHOTOS = {
  malak: `${BASE}/malak.jpg`,
  karan: `${BASE}/karan.jpg`,
  karim: `${BASE}/karim.jpg`,
  bilal: `${BASE}/bilal.jpg`,
} as const;

/** Headshot URL for a team member, or undefined if we don't have one for them. */
export function photoFor(name: string): string | undefined {
  const key = name.trim().toLowerCase().split(/\s+/)[0] || '';
  return TEAM_PHOTOS[key as keyof typeof TEAM_PHOTOS];
}
